<template>
  <div class="queue-list">
    <div class="vx-row flex-col items-center justify-center w-full mb-5">
      <div class="p-3 pb-2">
        <img :src="queueList.logo | agencyLogo" alt width="75px" />
      </div>
      <div class="text-4xl overflow-hidden font-semibold">{{queueList.service_name || "Not Available"}}</div>
    </div> 
    <div class="vx-row" v-if="queueList.queue.length == 0" >
      <vs-card>
        <div class="flex items-center">
          <div class="text-xl">#</div>
          <div class="text-2xl flex-1 text-center">Antrian Kosong</div>
        </div>
      </vs-card>
    </div>
    <div class="vx-row" v-else>
      <vs-card v-for="(queue,index) in queueList.queue" :key="index">
        <div class="flex items-center">
          <div class="text-xl">#{{index+1}}</div>
          <div class="text-4xl flex-1 text-center">{{queue.ticket_code}}</div>
        </div>
      </vs-card>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    queueList: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      services: []
    };
  },
  methods: {
    mapListQueue(data) {
      let lists = [];
      data.map(cluster => {
        cluster.data.map(item => {
          if (["waiting", "calling", "skipped"].includes(item.status)) {
            lists.push(item);
          }
        });
      });
      return lists;
    }
  }
};
</script>